import Sentry from 'shared/helpers/sentry';

export default Sentry;
